import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../config/apiConfig';

const DomainDetailPage = () => {
    const { id } = useParams();
    const [domain, setDomain] = useState(null);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const resDomain = await axios.get(`${API_URL}/admin/domains`, {
                    params: { adminKey: process.env.REACT_APP_ADMIN_KEY }
                });
                if (resDomain.data.success) {
                    const found = resDomain.data.data.domains.find(d => d.id === id);
                    setDomain(found);
                }
                const resUsers = await axios.get(`${API_URL}/admin/domains/${id}/users`, {
                    params: { adminKey: process.env.REACT_APP_ADMIN_KEY }
                });
                if (resUsers.data.success) {
                    setUsers(resUsers.data.data);
                }
            } catch (err) {
                console.error('Erreur lors du chargement:', err);
            }
        };
        fetchData();
    }, [id]);

    if (!domain) return <p>Chargement...</p>;

    return (
        <div>
            <h1 className="text-2xl font-semibold text-gray-700 mb-4">{domain.domain}</h1>
            <p className="mb-2">Statut: {domain.status}</p>
            <h2 className="text-xl font-semibold mt-6 mb-2">Utilisateurs</h2>
            <ul className="list-disc list-inside">
                {users.map(u => (
                    <li key={u.id}>{u.email}</li>
                ))}
            </ul>
        </div>
    );
};

export default DomainDetailPage;